module.exports = __webpack_public_path__ + "static/media/xiuguluanshan1.fdc192f2.jpg";